function parseErrorResponse(response, fallback = "") {
  const responseJSON = response.responseJSON || {};
  const errors = responseJSON.errors || [];

  return errors[0] || fallback;
}

module.exports = { parseErrorResponse };
